import { createContext } from 'react';

const touchesContext = createContext();

export default touchesContext;
